{
  // item-options-modal
  "onceOnly": "einmalig",
  "noLongerDeliver": "abbestellen",
  "everyWeek": "wöchentlich (W)",
  "every2Weeks": "2 wöchentlich (2W)",
  "every4Weeks": "4 wöchentlich (4W)",
  "howOftenDelivery": "<b>Wie oft</b> soll der Artikel geliefert werden?",
  "howManyUnits": "<b>Wieviele Einheiten</b> des Artikels sollen geliefert werden?",
  "firstTimeDelivery": "Der Artikel wird <b>erstmalig</b> geliefert am:",
  "nextTimeDelivery": "Der Artikel wird <b>das nächste Mal</b> geliefert am:",
  "oneTimeDelivery": "Der Artikel wird <b>einmalig</b> geliefert am:",
  "lastTimeDelivery": "Der Artikel wird <b>letztmalig</b> geliefert am:",
  "confirm": "Bestätigen",
  "deliveryDescription": "Der Artikel wird ab dem gewünschten Zeitraum im ausgewählten Abstand regelmäßig geliefert, sofern verfügbar.",
  "postcodeError": "Die Adresse muss zur Postleitzahl {postcode} gehören",
  "missingStreetNumber": "Bitte geben Sie eine Hausnummer an.",
  "noResultFromPlacesAPI": "Keine Ergebnisse gefunden. Bitte versuche es erneut.",
  "noCordinatesFoundForAddress": "Bitte geben Sie die Adresse erneut ein. Wir konnten keine genaue Adresse finden.",
  // payment-element-stripe
  "paymentMethods": "Bezahlmethode auswählen",
  "invoice": "Kauf auf Rechnung",
  "sepa": "SEPA",
  "processing": "... in Bearbeitung ...",
  // cart-summary
  "yourCartItemsWillBeLost": "Dein Warenkorbinhalt wird geleert.",
  "rulesWillBeReset": "Alle Regeln werden zurückgesetzt.",
  "changeYourDeliveryToThisEarlierDate": "Wechsle deinen Liefertag zu diesem früheren Zeitpunkt:",
  "timeLeftMessage": "Es bleiben {remaining_time} zum Bestellen. Der Bestellschluss ist {closing_time_str}.",
  "switchToEarlierDelivery": "auf früheres Lieferdatum wechseln",
  "switchDelivery": "Liefertag wechseln",
  "to": "zu",
  "soldOut": "Ausverkauft - bald wieder da",
  "totalPrice": "Warenwert",
  "waiveDeliveryFee": "kostenlos ab {waive_delivery_above}€",
  "orderDeadline": "Bestellschluss {remaining_str}",
  "orderDeadlineExpired": "Bestellschluss abgelaufen!",
  "deposit": "Pfand",
  "checkedOrdered": "✔ bestellt",
  "resetChanges": "unbestellte Änderungen zurücksetzen",
  "cancelledOrPaused": "⨯ storniert / pausiert",
  "cancelled": "⨯ storniert",
  "deliveryFee": "Liefergebühr",
  "shippingFee": "Versandkosten",
  // payment
  "payment_card": "Kreditkarte",
  "payment_sepa": "SEPA - Lastschrift",
  "payment_invoice": "Auf Rechnung",
  "paymentErrorMessage": "Mit deiner Zahlungsmethode ist etwas schiefgelaufen. Bitte versuche es erneut oder kontaktiere {contactLink} für Unterstützung.",
  "contactSupport": "unser Support-Team",
  "autobuyNotification": "Da du aktuell deinen Warenkorb im Abo bekommst, werden dir keine Bestellfenster- und Erinnerungsmail zugeschickt.",
  "saveSettings": "Einstellungen speichern",
  "orderWindowEmail": "Bestellfensteremail",
  "reminderEmail": "Erinnerungsemail",
  "companyDeliverySubscription": "{company}-Lieferung im Abo",
  "subscribeToCompanyDelivery": "{company}-Lieferung abonnieren",
  "subscribeEnabled": "Dein Warenkorb wird automatisch zur ausgewählten Häufigkeit geliefert. Über die Bestellbestätigung kannst du dein Abo bis zum Bestellschluss anpassen.",
  "subscribeDisabled": "Erhalte deine {company}-Lieferung im Abo, indem du Produkte aus der Liste unten hinzufügst. Du kannst dein Abo jederzeit anpassen.",
  "favourites": "Favoriten",
  "searchResults": "Suchergebnisse",

  "syncWithCartLabel": "Änderung auch für aktuellen Warenkorb übernehmen",
  "syncWithRuleLabel": "Änderung für alle zukünftigen Lieferungen übernehmen",
  "adjustOrderForDate": "Bestellung zum {date} anpassen",

  "periodicityError": "Mindestens eine Auswahl muss getroffen werden.",
  "amountError": "Anzahl muss mindestens 1 sein.",

  "cart": "Warenkorb",
  "setting": "Profil & Einstellungen",

  "amountError": "Anzahl muss mindestens 1 sein.",
  "systemChangePaymentMethod": "Aufgrund einer Systemumstellung bitte Bezahlmethode ändern",
  "currentPaymentMethod": "Aktuelle Bezahlmethode:",
  "accountHolder": "Kontoinhaber",
  "changePaymentMethod": "Bezahlmethode ändern",
  // PaymentInHouse
  "sepaMandate": "SEPA-Lastschriftmandat",
  "creditorIdentifier": "Gläubiger-Identifikationsnummer: ",
  "mandateReferenceNumber": "Mandatsreferenznummer: ",
  "dealer": "Händler",
  "mandateAuthorisationStatement": "Ich ermächtige <strong>{gmbhName}</strong> widerruflich, laut meinen vorherigen Eingaben die von mir zukünftig zu entrichtenden Zahlungen bei Fälligkeit von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von <strong>{gmbhName}</strong> auf mein Konto gezogenen Lastschriften einzulösen.",
  "refundStatement": "<strong>Hinweis:</strong> Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen.",
  "confirmSepa": "Hiermit bestätige ich das SEPA-Lastschriftmandat *",
  // cart-order-bar
  "inclusive": "inklusive",
  "exclusive": "exklusive",
  "vatText": "Alle Preise verstehen sich {incl_excl} MwSt. und zzgl. Pfand und Liefergebühr",
  "minSalesPriceText": "noch {remaining_to_min_sale_price}€ bis zum Mindestbestellwert",
  "ordered": "Bestellt",
  "cartNotOrdered": "Warenkorb wurde nicht bestellt",
  "order": "Bestellen",
  "editOrder": "Bestellung anpassen",
  "cancel": "Stornieren",
  "pause": "Pausieren",
  // catalog-item-list
  "categories": "Kategorien",
  "other": "Sonstige",
  "suggestions": "Empfehlungen",
  "allProductsInCart": "Du hast alle Produkte im Warenkorb",
  // Ordering Info
  "expiredDeadlineMsg": "Der Bestellschluss für diesen Liefertag ist <strong>abgelaufen</strong>.",
  "newOrder": "Neue Bestellung aufgeben",
  "openOrderWindow": "Das Bestellfenster ist offen!",
  "closes": "schließt",
  "orderingWindowExtended": "Bestellfenster wurde über das Bestellfenster hinaus erweitert.",
  "oneTimeOrder": "Bestellung ist einmalig möglich.",
  "youCanCancelCart": "Du kannst den Warenkorb jetzt stornieren.",
  "deliveryIsPaused": "Lieferung wird ausgesetzt.",
  "cartCancelled": "Warenkorb wurde storniert.",
  "changeMind": "Wenn du es dir anders überlegst, füge innerhalb des Bestellfensters Produkte hinzu und bestelle wie gewohnt",
  "orderWindowOpens": "Das Bestellfenster öffnet <strong>{days_until_ordering_window_opens_str}</strong>",
  "reminderByEmail": "Du wirst per Email erinnert!",
  "activateReminder": "Schalte die Erinnerung in den Einstellungen ein!",
  "clickPause": "Klicke <strong>Pausieren</strong> um dein Abo für diesen Liefertag auszusetzen.",
  "cartWithSubscribeRules": "Dieser Warenkorb wird <strong>{days_until_ordering_window_opens_str}</strong> automatisch mit Produkten aus deinem Abo gefüllt.",
  "cartWithProposalRules": "Dieser Warenkorb wird <strong>{days_until_ordering_window_opens_str}</strong> automatisch mit deinen ausgewählten Produkten vorausgefüllt.",
  "unlessYouOrderManually": "...außer Du kaufst diesen Warenkorb vorher",
  "contactNewOrder": "Kontaktiere {companyEmail} um eine neue Bestellung aufzugeben",
  "welcomeInShop": "Willkommen im {companyName} Shop.",
  "viewOrderingWindow": "Lieferzeitfenster ansehen",
  "remainingTimeDays": "in {remaining_time} Tagen",
  "remainingTimeHours": "in {remaining_time} Stunden",
  // SearchBar
  "searchPrompt": "Produkt suchen",
  // Shop
  "checkDeliveryArea": "Liefergebiet prüfen",
  "useDifferentBrowser": "Bitte verwenden Sie einen anderen Browser. Die Webseite ist nicht für den Internet Explorer optimiert.",
  // CartHeader
  "selectDeliveryTime": "Lieferzeit auswählen",
  // welcome
  "backToShop": "Zurück zum Shop",
  "thankYou": "Vielen Dank!",
  "successfulRegistration": "Deine Registrierung ist erfolgreich.",
  "orderConfirmationMail": "Gleich kommt eine Bestellbestätigung per Mail.",
  // Register
  "register": "Registrierung",
  // PickupForm
  "loginDetails": "Zugangsdaten",
  "password": "Passwort",
  "passwordRequirement": "Anforderung mind. 6 Zeichen davon 1 Zahl und 1 Sonderzeichen",
  "pickupAddress": "Abholadresse",
  "streetAndHouseNumber": "Straße & Hausnummer",
  "postcode": "PLZ",
  "city": "Ort",
  "timeslot": "Abholzeiten",
  "hintChanges": "Hinweis: Soll die Abholstation geändert oder doch an die Haustür geliefert werden, dann sende bitte eine Mail an: {companyEmail}",
  "private": "privat",
  "business": "geschäftlich",
  "billingAddress": "Rechnungsadresse",
  "countryCode": "Ländercode (DE)*",
  "phoneNumber": "Telefonnummer*",
  "saveChanges": "Änderung bestätigen",
  "saveAndContinue": "Speichern & Weiter",
  "contactPerson": "Firmen Ansprechpartner:in",
  "companyName": "Firmenname",
  // RequiredCaption
  "requiredFields": "* Pflichtfelder",
  // Profile
  "termsAndConditions": "AGB ",
  "agreementPreamble": "*Mit der Bestellung erkläre ich mich mit der ",
  "ofCompany": "von {gmbhName} einverstanden.",
  // DeliveryForm
  "deliveryAddress": "Lieferadresse",
  "shippingAddress": "Versandadresse",
  "name": "Vorname",
  "surname": "Nachname",
  "deliveryHints": "Lieferhinweise - z.B. Stockwerk, Hinterhof",
  "hintChangesDelivery": "Hinweis: die {delivery_or_shipping_name} kann nur im gleichen PLZ Bereich angepasst werden, wenn diese geändert werden soll, oder Du lieber zu einer unserer Abholstationen wechseln willst, sende bitte eine Mail an: {companyEmail}",
  "differentBillingAddress": "Rechnungsadresse abweichend",
  // InputAutocomplete
  "streetAndHouseNumberAutocomplete": "Straße & Hausnummer*",
  // Cart
  "havePatience": "Bitte habe einen Moment Geduld... ",
  "havePatienceWhileProcessing": "Bitte habe einen Moment Geduld, deine Bestellung wird verarbeitet...",
  "successfulPaymentMethod": "Zahlungsmittel erfolgreich hinterlegt.",
  "errorPaymentMethod": "Fehler beim Hinterlegen des Zahlungsmittels. Bitte versuche es erneut.",
  "failedPaymentMethod": "Die Zahlungsmethode konnte nicht hinzugefügt werden. Bitte versuche es erneut oder wähle eine andere Zahlungsmethode.",
  "unorderedChanges": "Warenkorb enthält unbestellte Änderungen.",
  "undoChanges": "Klicke hier um unbestellte Änderungen zurückzusetzen.",
  "saveUnorderedChanges": "Um die Änderungen zu speichern einfach auf Bestellen drücken.",
  "adjustedProducts": "Die folgenden Produkte im Warenkorb wurden mangels Verfügbarkeit angepasst.",
  "cancelOrder": "Bestellung stornieren",
  "cancelOrderConfirmation": "Möchtest Du wirklich diese Bestellung stornieren?",
  "cancelOrderItemsWarning": "Alle Warenkorbartikel werden gelöscht.",
  // CartController
  "orderConfirmation": "Vielen Dank für deine Bestellung, gleich kommt eine Bestellbestätigung per Mail.",
  "cancelConfirmation": "Bestellung wurde storniert, gleich kommt eine Stornierbestätigung per Mail.",
  "pausedDelivery": "Liefertag wurde pausiert. Wenn du es dir anders überlegst, füge einfach Produkte hinzu und bestelle wie gewohnt",
  // CartItem
  "deposit_lc": "Pfand",
  "nutritionML": "Nährwerte pro 100ml",
  "nutritionG": "Nährwerte pro 100g",
  "pieceCa": "Stk ca ",
  // PasswordReset
  "resetPswd": "Passwort widerherstellen",
  "successfulPswdReset": "Dein Passwort wurde erfolgreich zurückgesetzt",
  // ChangePassword
  "oldPswd": "Altes Passwort",
  "newPswd": "Neues Passwort",
  "confirmNewPswd": "Neues Passwort bestätigen",
  "confirmChanges": "Änderung Bestätigen",
  // Contact
  "contactForQuestions": "Bei Fragen oder für Feedback erreichst Du uns hier:",
  "telephone": "Telefon",
  // DataProtection
  "dataProtectionHere": "Hier geht es zum Datenschutz:",
  "dataPrivacy": "Datenschutz",
  // Deposit
  "overviewDeposit": "Übersicht Rückgabe Pfand: ",
  "returnedAndCredited": " Folgende Pfandartikel wurden zurückgegeben und werden mit der nächsten Rechnung gutgeschrieben. Die Preise sind inkl MwSt ",
  "noCurrentReturns": "Es wurden aktuell keine Pfandartikel zurückgegeben",
  "total": "GESAMT",
  // Email
  "loginEmail": "Login & Korrespondenz Email",
  "billingEmailHint": "Rechnungs Email: nur ausfüllen wenn abweichend von der Login Email",
  "billingEmail": "Rechnungs Email",
  // Footer
  "impressum": "Impressum",
  "termsAndConditionsHc": "AGB",
  // CardProductTitle
  "contents": "Inhalt",
  // Invoices
  "receiptFrom": "Beleg vom ",
  "invoiceFrom": "Rechnung vom ",
  // Login
  "enterPsw": "Bitte gebe dein Passwort ein!",
  "forgotPsw": "Passwort vergessen?",
  // NutritionPanel
  "ingredients": "Zutaten",
  "producerInfo": "Herstellerinformationen",
  "productInfo": "Produktinformationen",
  "storageInfo": "Lagerungshinweis",
  "usageInfo": "Verwendungstipps",
  // Rule
  "mySubscribedProducts": "Meine abonnierten Produkte",
  "addProductsToSubscription": "Produkte zum Abo hinzufügen",
  "fillCartDescription": "Füge Produkte zu deinem Abo hinzu, damit sie automatisch geliefert werden.",

  "nextDeliveries": "Meine <b>nächsten Lieferungen</b> für die folgenden 4 Wochen.",
  "pauseInstructions": "<b>Zum Pausieren</b> bitte entsprechendes Datum abwählen.",
  "datesSelectionError": "Bitte wähle mindestens ein Datum aus.",
  "productManagement": "Produktverwaltung",
  "cannotDeselectSameDeliveryDate": "Dieses Datum kann nicht abgewählt werden, da das Bestellfenster bereits geöffnet ist.",
  "pricesSubjectToChange": "* Preise können sich im Laufe der Zeit ändern",
  "dateSelectedMessage": "Du hast den {date} aktiviert. Deine nächste Lieferung ist für den {nextDelivery} geplant.",
  "dateSelectedMessageSameDate": "Du hast den {date} aktiviert. Deine nächste Lieferung bleibt für den {nextDelivery} bestehen.",
  "dateDeselectedMessage": "Du hast den {date} deaktiviert. Deine nächste Lieferung ist für den {nextDelivery} geplant.",
  "dateDeselectedMessageSameDate": "Du hast den {date} deaktiviert. Deine nächste Lieferung bleibt für den {nextDelivery} bestehen.",
  "datePausedMessage": "Du hast den {date} pausiert. Deine nächste Lieferung ist für den {nextDelivery} geplant.",
  "datePausedMessageSameDate": "Du hast den {date} pausiert. Deine nächste Lieferung bleibt für den {nextDelivery} bestehen.",
  "scheduledDelivery": "Deine nächste Lieferung ist geplant für: {date}",
  "soldLabel": "VERKAUFT",
  "inactiveLabel": "GESCHLOSSEN",
  "pausedLabel": "PAUSIERT",
  "noSearchResults": "Keine Ergebnisse gefunden",
  "deliveringOn": "Lieferung am: {date}",
  "notDeliveringOn": "Keine Lieferung am: {date}",
  // Settings
  "subscription": "Aboverwaltung",
  "notifications": "Benachrichtigungen",
  "invoiceTab": "Rechnungen",
  "addresses": "Adressen",
  "paymentMethod": "Zahlungsmittel",
  "changePsw": "Passwort ändern",
  "contact": "Kontakt",
  "unlockMoreSettings": "Mehr Einstellungen werden freigeschaltet nach Kauf des ersten Warenkorbs.",
  // Terms
  "findTermsHere": "Unsere aktuellen Allgemeinen Geschäftsbedingungen findest Du hier:",
  "all": "Alle",

  // UpcomingDeliveries
  "upcomingDeliveries": "Zukünftige Lieferungen",
  "noUpcomingDeliveries": "Keine zukünftigen Lieferungen gefunden",
  "redirectingToCart": "Weiterleitung zum Warenkorb...",
  "daysUntilDeadline": "Bestellschluss in {days} Tagen",
  "hoursUntilDeadline": "Bestellschluss in {hours} Stunden",
  "orderDeadlinePassed": "Anpassung/Stornierung nicht mehr möglich",
  "weekdayMovedFrom": "| verschoben von {originalDay}",
  "filterOrdered": "bestellt",
  "filterPaused": "pausiert/storniert",
  "filterEditable": "anpassbar",
  "clearFilter": "Filter löschen",
  // Delivery Status
  "deliveryStatus.sold": "Bestellt",
  "deliveryStatus.cancelled": "Storniert",
  "deliveryStatus.paused": "Pausiert",
  "deliveryStatus.ordered": "Bestellt",
  "deliveryStatus.open": "Offen",
  "deliveryStatus.closed": "Abgelaufen",
  "deliveryStatus.delivered": "Bestellung geliefert",
  // PastDeliveries
  "pastDeliveries": "Rechnungen & Vergangene Lieferungen",
  "weekNumber": "KW {number}",
  "pastDeliveriesOpen": "Rechnung in Erstellung",
  "pastDeliveriesInvoiced": "Rechnung abgerechnet",
  "orderPausedCancelled": "Bestellung pausiert/storniert",
  // useDeliveries hook
  "weekday_1": "Montag",
  "weekday_2": "Dienstag",
  "weekday_3": "Mittwoch",
  "weekday_4": "Donnerstag",
  "weekday_5": "Freitag",
  "weekday_6": "Samstag",
  "weekday_7": "Sonntag",
  "weekdayShort_1": "Mo",
  "weekdayShort_2": "Di",
  "weekdayShort_3": "Mi",
  "weekdayShort_4": "Do",
  "weekdayShort_5": "Fr",
  "weekdayShort_6": "Sa",
  "weekdayShort_7": "So",
  // Shared UI
  "totalAmount": "Summe",
  "summe": "Summe",
  "rechnung": "Rechnung",
  "showMore": "Mehr",
  "loading": "Wird geladen...",
  "noDeliveriesInCategory": "Keine Lieferungen in dieser Kategorie",
  "noEntriesAvailable": "Keine Einträge vorhanden",
  "forceEditable": "Nach Bestellschluss anpassen",
  "backToMuli": "zurück zu MULI",

  // Packing Notes
  "note": "Notiz",
  "addNoteToCart": "Notiz zum Warenkorb hinzufügen",
  "addNoteToCartPlaceholder": "Notiz hinzufügen fürs Packen des Warenkorbs..."
}
